/* eslint-disable default-case, no-param-reassign */
/*
 *
 * Mobile reducer
 *
 */

import produce from 'immer';

import {
  CLEAR_NATIVE_SESSION,
  SET_IS_IN_APP_REVIEW_SUPPORTED,
  SET_IS_MOBILE,
  SET_NATIVE_CLIENT_LIST,
  SET_NATIVE_SESSION,
  SET_NESTED_SCREEN,
} from './constants';

export const initialState = {
  clients: [],
  isInAppReviewSupported: false,
  isMobile: false,
  isNativeMobile: false,
  nestedScreen: {
    calculators: '',
    documents: '',
    help: '',
    mortgage: '',
    payments: '',
    settings: '',
  },
  session: {},
};

export const mobileReducer = produce((draft, { payload, type }) => {
  switch (type) {
    case CLEAR_NATIVE_SESSION: {
      draft.session = initialState.session;
      break;
    }
    case SET_IS_IN_APP_REVIEW_SUPPORTED: {
      const { isSupported } = payload;
      draft.isInAppReviewSupported = isSupported;
      break;
    }
    case SET_IS_MOBILE: {
      const { isNativeMobile } = payload;
      draft.isMobile = true;
      draft.isNativeMobile = isNativeMobile;
      break;
    }
    case SET_NATIVE_CLIENT_LIST: {
      const { clients } = payload;
      draft.clients = clients;
      break;
    }
    case SET_NATIVE_SESSION: {
      const { session } = payload;
      draft.session = {
        ...draft.session,
        ...session,
      };
      break;
    }
    case SET_NESTED_SCREEN: {
      const { mainScreen, nestedScreen } = payload;
      draft.nestedScreen[mainScreen] = nestedScreen;
      break;
    }
  }
}, initialState);

export default mobileReducer;
